import {ThemeConfig} from 'antd';

export const themeConfig: ThemeConfig = {
   components: {
      Layout: {
         headerBg: 'rgb(173,223,249)',
         siderBg: '#fff',
      }
   },
}
